import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { LeadCommunicationService } from 'src/app/private/services/micro-services/leadCommunication.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-communication-note',
  imports: [SharedModule],
  templateUrl: './communication-note.component.html',
  styleUrl: './communication-note.component.scss'
})
export class CommunicationNoteComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() communicationData: any = {};
  @Input() hangUpCallData : any = {};
  @Input() timeWhenCallStarted: any;
  @Input() emailExtraDetails: any = {};
  @Input() type : string = 'call';
  note: string = '';
  isAddNoteLoading: boolean = false;
  

  constructor(
    private api : LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private CommunicationService: LeadCommunicationService,
    private leadActivityService: LeadActivityService
  ) { }

  ngOnInit(): void {
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  saveNotes() {
  
      this.isAddNoteLoading = true;
      const payload = {

        "lead_id": this.communicationData?.lead_id,
        "organization_id": this.localStorage.getOrganizationId(),
        "communication_type": this.type,
        "note": this.note,
        "date_of_communication": new Date().toISOString().split('T')[0],
        "time_of_communication": this.type == 'call' ? this.timeWhenCallStarted.toTimeString().split(' ')[0] : null,
        "call_extra_details": this.hangUpCallData,
        "email_extra_details": this.emailExtraDetails,
        "status": this.type == 'call' ?  this.hangUpCallData?.channel_id !== null ? "Connected" : "Disconnected" : 'Sent',
        "user_id": this.localStorage.getUserId(),
      }

      this.api.createLeadCommunicationLog(payload).subscribe({
        next: (res: any) => {

          if(this.type == 'call') {
            this.CommunicationService.addCallData(res);
          } else {
            this.CommunicationService.addEmailData(res);
          }

          this.leadActivityService.getAllLeadTimeLineActivity(this.communicationData?.lead_id);


          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Communication details saved successfully'
          });
          this.isAddNoteLoading = false;
          this.closeDialog.emit();
        },
        error: (err: any) => {
          this.isAddNoteLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error saving communication details'
          });
        }
      });
  }

}
